import React, { memo } from 'react';
import ReactDOM from 'react-dom';
import { useServiceSelector } from 'react-service-locator';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import { FlexColumn } from 'src/components/layout/flex-column';
import { BreadcrumbsService } from 'src/services/breadcrumbs.service';

const BetaBadge = styled(FlexColumn)`
  align-items: center;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 3px;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.font.bold};
  font-size: 9px;
  height: 19px;
  justify-content: center;
  margin-left: 10px;
  padding: 1px 3px 0px 3px;
  width: 34px;

  ${up('md')} {
    background: ${({ theme }) => theme.colors.secondaryMint10};
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme.colors.secondaryMint60};
    color: ${({ theme }) => theme.colors.secondaryMintDark};
    padding: 4px 7px 3px 7px;
    width: 38px;
  }
`;

export const BreadcrumbBetaBadge = memo(() => {
  const breadcrumbRoutes = useServiceSelector(BreadcrumbsService, (s) => s.state.routes);

  const headerExtraContentElement = document.getElementById('header-extra-content');

  if (breadcrumbRoutes.length === 0 || !headerExtraContentElement) {
    return null;
  }

  return ReactDOM.createPortal(<BetaBadge>BETA</BetaBadge>, headerExtraContentElement);
});
